import { DocScanFieldResult } from "models";

import { EvidenceSignal, EvidenceTone } from "pages/admin/verifications/components/automations/types";

const EMPTY_SUMMARY_VALUE = "—";

export const formatSizeVariance = (sizeVariancePct: number) => `${sizeVariancePct > 0 ? "+" : ""}${sizeVariancePct.toFixed(1)}%`;

export const formatSummaryCount = (count: number) => (count ? String(count) : EMPTY_SUMMARY_VALUE);

export const formatSummaryPercent = (percent: number) => (percent ? `${percent}%` : EMPTY_SUMMARY_VALUE);

export const getDocScanEvidenceTone = ({ status }: DocScanFieldResult): EvidenceTone => (status === "mismatch" ? "danger" : "success");

export const getDocScanEvidenceTitle = ({ cropStatus, sizeStatus }: DocScanFieldResult) => {
  const issues = [cropStatus === "mismatch" && "Crop mismatch", sizeStatus === "excessive" && "Size diff"].filter(Boolean);
  return issues.length ? issues.join(" · ") : "Doc match";
};

const getCropSignal = ({ cropStatus }: DocScanFieldResult, withLabel: boolean): EvidenceSignal | null => {
  if (!cropStatus) return null;
  const isMatch = cropStatus === "match";
  return {
    key: "crop",
    iconName: isMatch ? "tabler/file-check" : "tabler/file-x",
    tone: isMatch ? "success" : "danger",
    label: withLabel ? (isMatch ? "Crop match" : "Crop mismatch") : undefined,
  };
};

const getSizeSignal = ({ sizeStatus, sizeVariancePct }: DocScanFieldResult, withLabel: boolean): EvidenceSignal | null => {
  if (!sizeStatus) return null;
  const variance = sizeStatus === "excessive" && sizeVariancePct !== null ? formatSizeVariance(sizeVariancePct) : undefined;
  return {
    key: "size",
    iconName: "tabler/ruler",
    tone: sizeStatus === "ok" ? "success" : "danger",
    label: withLabel ? `Area ${variance ?? (sizeStatus === "ok" ? "ok" : "differs")}` : variance,
  };
};

const getDocScanSignals = (result: DocScanFieldResult, withLabel: boolean) =>
  [getCropSignal(result, withLabel), getSizeSignal(result, withLabel)].filter((signal): signal is EvidenceSignal => !!signal);

export const getDocScanTileSignals = (result: DocScanFieldResult) => getDocScanSignals(result, false);

export const getDocScanRowSignals = (result: DocScanFieldResult) => getDocScanSignals(result, true);
